import { GenericNodePreloaderRules } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/preloader.rules'

import { WhatsAppNodePreloaderRules } from './whatsapp/nodes/preloader.rules'

export const NodePreloaderRules = [...WhatsAppNodePreloaderRules, ...GenericNodePreloaderRules]
